
import { DataManagerService, FeatureSelection } from './../../model/services/data-manager.service';
import { DrawMode, DrawPaneComponent } from './../draw-pane/draw-pane.component';
import { RouteConfigOKHandlerParams } from './../dialogs/route-config-dialog/route-config-entry/route-config-entry.component';
import { ObjID } from 'app/model/id-manager';
import { StatefulCSS } from './../../model/stateful_css';
import { RouteID, RoutesChange, RouteTreeNode, RoutesService } from './../../model/services/routes.service';
import { ModalMessagerService } from './../dialogs/modal-messager/modal-messager.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, EventEmitter, ElementRef, ErrorHandler } from '@angular/core';
import { MatTree, MatTreeNestedDataSource } from '@angular/material/tree';
import { RouteService, RouteInfo } from 'app/model/services/route.service';
import { Project } from 'app/model/project';
import { Route } from 'app/types/route-data';
import { RouteConfigDialogService } from '../dialogs/route-config-dialog/route-config-dialog.service';

export type LayerToolType = 'config' | 'move-up' | 'move-down' | 'move' | 'jump-to' | 'add' | 'delete' | 'delSelVertex' | 'delVertices' | 'gps-add' | 'gps-update' | 'branch-merge';

@Component({
  selector: 'app-layer-list',
  templateUrl: './layer-list.component.html',
  styleUrls: ['./layer-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayerListComponent implements AfterViewInit {
  public treeControl = new NestedTreeControl<RouteTreeNode>(node => (!!node) ? node.children : []);
  public dataSource = new MatTreeNestedDataSource<RouteTreeNode>();
  public treeData: Array<RouteTreeNode> = [
    {
      name: 'Routes',
      children: [],
      id: 0,
      index: 0,
      hasChildren: true
    }
  ];
  private _drawMode: 'view' | 'edit' = 'edit';
  @Input() set drawMode(mode: 'view' | 'edit') {
    this._drawMode = mode;
    this.Refresh();
  }
  get drawMode() {
    return this._drawMode;
  }

  private _project?: Project;
  @Input()
  set project(proj: Project | undefined) {
    this._project = proj;
    this._project?.drawPaneReady.subscribe(() => {
      this._project?.drawPane?.drawModeChange.subscribe((mode: DrawMode) => {
        if (mode !== 'merge') {
          this.branchMerging = undefined;
          this.Refresh();
        }
      })
    })
    this.Refresh();
  }
  get project(): Project | undefined {
    return this._project;
  }

  @Input()
  public selectedNode: RouteTreeNode = this.treeData[0];
  @Output()
  public selectedNodeChange = new EventEmitter<RouteTreeNode>();

  @Output()
  public onRemoval = new EventEmitter<RouteID>();

  @Output()
  public onSelect = new EventEmitter<RouteID>();

  private _ready: boolean = false;
  @ViewChild('tree') tree?: MatTree<any>;

  public get isMoving(): boolean {
    return this.modeStates.GetCurrentState() === 'moving';
  }
  public set isMoving(isIt: boolean) {
    this.modeStates.SetState(isIt ? 'moving' : 'display');
    this.Refresh();
  }

  _featureSelectsRoute: boolean = false;
  public set featureSelectsRoute(v: boolean) {
    this._featureSelectsRoute = v;
    this.Refresh();
  }
  public get featureSelectsRoute(): boolean {
    return this._featureSelectsRoute;
  }

  private movingId?: RouteID;
  private modeStates: StatefulCSS = new StatefulCSS();
  private branchMerging?: { route: any, feature: any };
  private _hasFeatureLU: Array<boolean> = [];
  private featureSelection?: FeatureSelection;
  public get isBranchMerging(): boolean { return !!this.branchMerging; }

  @ViewChild('class.hidden') hidden: boolean = true;

  constructor(private cdr: ChangeDetectorRef,
    private routes: RoutesService,
    private route: RouteService,
    private messager: ModalMessagerService,
    private config: RouteConfigDialogService,
    private domNode: ElementRef,
    private dataMgr: DataManagerService) {
    RoutesService.onChange.subscribe((changes: RoutesChange) => {
      switch (changes.change) {
        case 'route-added':
          this.UpdateTree(true);
          if (!this.treeData[0].children) {
            if (changes.handled) {
              changes.handled();
            }
            return;
          }
          requestAnimationFrame(() => {
            if (!this.treeData[0].children) return;
            for (const node of this.treeControl.getDescendants(this.treeData[0])) {
              if (node.id === changes.route) {
                this.Select(node);
                if (changes.handled) {
                  changes.handled();
                }
                break;
              }
            }
          });
          break;
        case 'feature-selected':
          const feature: any = this.route.context?.idRegistry.Get(changes.feature!);
          const selRoute: RouteInfo = this.route.GetRoute(changes.route);
          if (!(!!feature && !!feature.routes)) return;

          if (this.isBranchMerging && changes.route) {
            this.MergeBranches(selRoute, feature);
            return;
          }

          let match = false;
          for (const route of feature.routes) {
            if (route === this.selectedNode.id) {
              match = true;
            }

          }
          if (match === true) return;
          const route = changes.route;
          if (this.selectedNode.id === route) return;
          if (this.featureSelectsRoute) {
            this.SelectById(route);
          }

          if (changes.handled) {
            changes.handled();
          }
          break;
      }
      this.Refresh();
    });
  }

  hasChild(_: number, node: RouteTreeNode) {
    return !!node.children && node.children.length > 0;
  }
  ngAfterViewInit(): void {
    this.modeStates.SetPrefix('mode');
    this.modeStates.AddState('display');
    this.modeStates.AddState('moving');
    this.modeStates.SetMachine(this.domNode.nativeElement);
    this.modeStates.SetState('display');
    this._ready = true;
    this.UpdateTree(true);


    this.Refresh();
    this.dataMgr.onSelect.subscribe((selection: FeatureSelection) => {
      this.featureSelection = selection;
      this._hasFeatureLU = [];
      this.Refresh();
      if (!selection) return;
      if (this.dataMgr.GetProject()?.viewMode === 'view') return;
      if (this.selectedNode.id !== selection.route.id) {
        this.SelectById(selection.route.id, false);
      }
    });

  }
  Refresh() {
    if (this._ready) {
      this.cdr.detectChanges();
    }
  }
  UpdateTree(rebuild: boolean) {
    if (rebuild === true) {
      this.treeData[0].children = this.routes.GetTree();
      this.hidden = false;
    }
    //this.treeData[0].id = this.treeData[0].id === 0 ? -1 : 0;
    this.dataSource.data = [];
    this.treeControl.dataNodes = [];
    this.tree!.renderNodeChanges(this.dataSource.data);
    this.dataSource.data = this.treeData;
    this.treeControl.dataNodes = this.treeData;
    this.tree!.renderNodeChanges(this.dataSource.data);
    this.Refresh();
    this.treeControl.expand(this.treeControl.dataNodes[0]);
    this.treeControl.expandDescendants(this.treeControl.dataNodes[0]);
    this.Refresh();
  }
  ToggleNode(node: RouteTreeNode) {
    this.treeControl.toggle(node);
    this.treeControl.options
    const isVis = this.treeControl.isExpanded(node);
    const route = this.project?.idRegistry.Get(node.id) as Route;
    if (!!route) {
      route.expanded = this.treeControl.isExpanded(node);
      RoutesService.Notify('route-change', route.id as number);
    }
    node._visible = isVis;
  }
  IsSelected(node: RouteTreeNode) {
    return node.id === this.selectedNode.id;
  }
  IsNotSelected(node: RouteTreeNode) {
    return !this.IsSelected(node);
  }
  SelectById(routeId: number, autoSelectFeature: boolean = true) {
    if (this.selectedNode.id === routeId) return;
    if (!this.treeData[0].children) return;
    if (routeId === 0) {
      this.dataMgr.DeSelect();
      this.Select(this.treeData[0], autoSelectFeature);
      return;
    }
    for (const node of this.treeControl.getDescendants(this.treeData[0])) {
      if (node.id === routeId) {
        this.Select(node, autoSelectFeature);
      }
    }
  }
  Select(node: RouteTreeNode, autoSelectFeature: boolean = true) {
    if (!!this.selectedNode) {
      if (this.selectedNode.id > 0) {
        this.route.GetRoute(this.selectedNode.id).feature?.DeselectFeature();
        this.route.GetRoute(this.selectedNode.id).feature?.DeselectRoute();
      }
    }
    this.selectedNode = node;
    this.onSelect.emit(node.id);
    if (this.selectedNode.id > 0) {
      this.route.GetRoute(this.selectedNode.id).feature?.SelectRoute(autoSelectFeature);
      this.route.GetRoute(this.selectedNode.id).feature?.SelectFeature();
    }
    // this.routes.SetSelected(this.selectionNode.id);
    this.Refresh();
    window.requestAnimationFrame(() => {
      const btns = document.getElementsByClassName('config-route-btn');
      if (btns && btns.length && btns.length > 0) {
        (btns[0] as HTMLButtonElement).focus();
      }
    })
  }
  HasSelectedFeature(node: RouteTreeNode) {
    if (node.id === 0) return false;
    if (!this.featureSelection?.feature) return false;
    if (this._hasFeatureLU[node.id] === undefined) {
      const feature = this.dataMgr.GetProject()?.idRegistry.Get(this.featureSelection?.feature);
      if (feature.routes) {
        this._hasFeatureLU[node.id] = feature.routes?.indexOf(node.id) > -1;
      } else {
        this._hasFeatureLU[node.id] = false;
      }
    }
    return this._hasFeatureLU[node.id];
  }
  IsRoot(node: RouteTreeNode) {
    return node.id === 0;
  }
  ShowTool(node: RouteTreeNode, tool: LayerToolType): boolean {
    switch (tool) {
      case 'move-up':
        {
          if (node.id <= 0) return false;
          if (!this.IsSelected(node)) return false;
          const peers = !!node.parent ? node.parent.children! : this.treeData[0].children!;
          if (peers.length <= 1) return false;
          if (peers[0].id === node.id) return false;
        }
        return true;
      case 'move-down':
        {
          if (node.id <= 0) return false;
          if (!this.IsSelected(node)) return false;
          const peers = !!node.parent ? node.parent.children! : this.treeData[0].children!;
          if (peers.length <= 1) return false;
          if (peers[peers.length - 1].id === node.id) return false;
        }
        return true;

      case 'move':
        if (node.id <= 0) return false;
        return true;
      case 'config':
        if (node.id <= 0) return false;
        return true;
      case 'jump-to':
        if (node.id <= 0) return false;
        const route = this.route.GetRoute(node.id);
        if (!route.feature) return false;
        return route.feature.points.length > 0;
      case 'delSelVertex':
        {
          if (this.drawMode === 'view') return false;
          if (node.id <= 0) return false;
          const route = this.route.GetRoute(node.id);
          if (!route.feature) return false;
          return route.feature.vertexSelected;
        }
      case 'delVertices':
        {
          if (this.drawMode === 'view') return false;
          if (node.id <= 0) return false;
          const route = this.route.GetRoute(node.id);
          return (!!route.feature) ? route.feature.hasVertices : false;
        }
      case 'gps-update':
        {
          if (this.drawMode === 'view') return false;
          if (node.id <= 0) return false;
          const route = this.route.GetRoute(node.id);
          const info = route.feature?.GetSelectedInfo();
          if (!info) return false;
          return !!info.type && (info.type === 'point');
        }
        return false;
      case 'gps-add':
      case 'delete':
        if (this.drawMode === 'view') return false;
        if (node.id === 0) return false;
        return true;
      case 'branch-merge':
        {
          if (this.drawMode === 'view') return false;
          if (node.id <= 0) return false;
          const route = this.route.GetRoute(node.id);
          const info = route.feature?.GetSelectedInfo();
          if (!info) return false;
          return !!info.type && (['point', 'segment'].indexOf(info.type) > -1);
        }
        return false;
      case 'add':
      default:
        return true;
    }
  }
  Delete(node: RouteTreeNode) {

    if (node.id === 0) {
      this.messager.Confirm('This operation cannot be undone without reloading the map. Are you sure you want too delete ALL routes in the current map? Click Ok to proceed, or Cancel to abort this operation.',
        () => {
          this.routes.RemoveAll();
          this.selectedNode = this.treeData[0];
          this.UpdateTree(false);
        }, null, 'Remove all routes?'
      );
      return;
    }
    const messageEnd = (!!node.children && (node.children.length > 0)) ? ' and all of its sub-routes?' : '?';
    this.messager.Confirm('This operation cannot be undone without reloading the map. Are you sure you want to delete route ' + node.name + messageEnd,
      () => {
        const id = node.id;
        this.RemoveNode(node);
        this.routes.RemoveRoute(node.id);
        this.selectedNode = !!node.parent ? node.parent : this.treeData[0];

        this.onRemoval.emit(id);
      }, null,
      'Remove ' + node.name
    );
  }
  GetFullName(node: RouteTreeNode): string {
    if (node.id === 0) return node.name;
    return this.route.GetFullName(node.id);
  }
  Add(node: RouteTreeNode) {

    if (node.id === 0) {
      this.config.Show({
        cancelHandler: () => { },
        okHandler: (params: RouteConfigOKHandlerParams) => {
          const node = this.routes.MakeNode(params.route.id!, this.treeData[0].children!.length);
          // this.treeData[0].children?.push(node);
          //this.UpdateTree(false);
          if (node) this.Select(node);
        },
        route: undefined
      })
    } else {
      const route = this.route.GetRoute(node.id);
      route.expanded = (!!route.children) ? route.children.length > 0 : false;

      const selected = route.feature?.GetSelectedInfo();
      const hasVertex = selected?.type === 'point';
      const hasSegment = selected?.type === 'segment';
      this.config.Show(
        {
          cancelHandler: () => { },
          okHandler: (params: RouteConfigOKHandlerParams) => {
            this.UpdateTree(false);
            if (hasSegment) {
              if (params.includeVertex === true) {
                const vertex = selected.split();
                params.route.feature!.AddVertex(vertex);
                vertex.share(params.route.feature!.id);
                params.route.feature?.Select(vertex.id, params.route.feature.id);
              }
              return;
            } if (hasVertex && params.includeVertex) {
              params.route.feature!.AddVertex(selected);
              selected.share(params.route.feature!.id);
              params.route.feature?.Select(selected.id, params.route.feature.id);
            }
            /*const peers = this.GetTreePeers(params.route.id!);
            const newNode = this.routes.MakeNode(params.route.id!, peers.length);
            newNode.parent = node;
            this._route.index = peers.length;
            peers.push(newNode);
            this.UpdateTree(false);
            if (newNode) this.Select(newNode);
            */
          },
          promptAddVertex: (hasVertex),
          promptAddSegVertex: (hasSegment),
          addTo: node.id
        }
      );
    }

  }
  IsTopRoute(node: RouteTreeNode): boolean {
    return (node.id === 0);
  }
  ToggleMoving(id: RouteID) {
    if (id === this.movingId) {
      this.isMoving = false;
      this.movingId = undefined;
      this.Refresh();
      return;
    }
    this.isMoving = true;
    this.movingId = id;
    this.Refresh();
  }
  IsMoveActive(id: RouteID) {
    return this.isMoving && (this.movingId === id)
  }
  IsMoveTarget(id: RouteID) {
    if (!this.movingId) return false;
    if (this.route.GetIDPath(id).indexOf(this.movingId) > -1) return false;
    return this.isMoving && (this.movingId !== id);
  }
  MoveTo(toId: RouteID) {
    if (!this.isMoving || (this.movingId === undefined)) {
      this.movingId = undefined;
      this.modeStates.SetState('display');
      this.Refresh();
      return;
    }
    const moveRoute = this.route.GetRoute(this.movingId);
    const toRoute = toId === 0 ? undefined : this.route.GetRoute(toId);
    const movePeers = this.GetTreePeers(this.movingId);
    let toPeers = this.GetTreePeers(toId);
    const toNode = toId === 0 ? this.treeData[0] : toPeers[toRoute?.index!];
    if (toNode) {
      if (!toNode.children) {
        toNode.children = [];
      }
      toPeers = toNode.children!;
    }

    if ([moveRoute.index].indexOf(undefined) > -1) return;
    let moveNode = movePeers[moveRoute.index!];

    if (moveRoute.parent && (moveRoute.index !== undefined)) {
      const moveParent = this.route.GetRoute(moveRoute.parent);
      moveParent.children?.splice(moveRoute.index, 1);
    }
    if (moveNode.parent) {
      moveNode.parent.children?.splice(moveRoute.index!, 1);
    } else {
      this.treeData[0].children?.splice(moveRoute.index!, 1);

    }

    let i = 0;
    for (i = moveRoute.index!; i < movePeers.length; i++) {
      movePeers[i].index = i;
      const remainingRoute = this.route.GetRoute(movePeers[i].id);
      if (remainingRoute) remainingRoute.index = i;
    }
    moveNode.index = toPeers.length;
    moveRoute.index = moveNode.index;
    if (!!toRoute) {
      if (!toRoute?.children) {
        toRoute.children = [];
      }
      toRoute?.children.push(moveRoute.id!);
    }
    toPeers.push(moveNode);
    if (!!toRoute) {
      moveNode.parent = toNode
      moveRoute.parent = toRoute.id;
    } else {
      moveRoute.parent = undefined;
      moveNode.parent = undefined;
    }
    /*if (toRoute.parent) {
      const toParent = this.route.GetRoute(toRoute.parent);
      if (toParent) toParent.children?.push(moveRoute.id!);
    }*/
    this.isMoving = false;
    this.movingId = undefined;
    this.UpdateTree(false);
  }
  Move(routeId: RouteID, direction: 'up' | 'down') {
    // Get route info and peer tree nodes
    const route = this.route.GetRoute(routeId);
    const peers = this.GetTreePeers(routeId);
    // make sure we have what we need to continue
    if (!(route)) return;
    if (route.index === undefined) return;
    const routeIndex = route.index;
    // setup offset and swap index
    const routeOffset = (direction === 'up') ? -1 : 1;
    const swapIndex = route.index + routeOffset;
    // make sure we can continue
    if (swapIndex < 0) return;
    if (swapIndex > peers.length) return;
    // get the current tree nodes for move route and swap route
    const routeNode = peers[route.index];
    const swapNode = peers[swapIndex];
    // swap the peer nodes;
    peers[routeIndex] = swapNode;
    peers[swapIndex] = routeNode;
    swapNode.index = routeIndex;
    routeNode.index = swapIndex;
    // update the index values for the corresponding route info objects.
    route.index = swapIndex;
    const swapRoute = this.route.GetRoute(swapNode.id);
    swapRoute.index = routeIndex;
    const rebuild = false;
    this.UpdateTree(rebuild);
  }
  GetNodeDepth(routeId: RouteID): number {
    const path = this.route.GetIndexPath(routeId);
    return path.length;
  }
  GetTreePeers(routeId: RouteID): Array<RouteTreeNode> {
    let children = this.treeData[0].children;
    if (routeId === 0) return children!
    const path = this.route.GetIndexPath(routeId);
    path.every((index: number) => {
      if (!children) {
        throw new Error('no children at index:' + index);
      }
      children = children[index].children;
      return true;
    });
    if (!children) throw new Error('no peers for route:' + routeId);
    return children;
  }
  RemoveNode(node: RouteTreeNode) {
    const peers = this.GetTreePeers(node.id);
    peers.splice(node.index, 1);
    for (let i = node.index; i < peers.length; i++) {
      peers[i].index = i;
      this.route.GetRoute(peers[i].id).index = i;
    }
    this.UpdateTree(false);
  }
  GetToolsMargin(node: RouteTreeNode): string {
    if (node.id === 0) return '';
    let depth: any = this.GetNodeDepth(node.id);
    depth += (node.children && node.children?.length) ? 0 : 1;
    const margin = `calc(0px - (${depth} * .5rem))`;
    return margin;
  }
  GetToolsWidth(node: RouteTreeNode): string {
    if (node.id === 0) return '';
    let depth: any = this.GetNodeDepth(node.id);
    depth += (node.children && node.children?.length) ? 0 : 1;
    return `calc(100% + (${depth} * .5rem))`;
  }
  IsNotRoot(node: RouteTreeNode): boolean {
    return node.id !== 0;
  }
  IsNodeVisible(node: RouteTreeNode): boolean {
    if (node.id <= 0) {
      return true;
    }
    const route = this.route.GetRoute(node.id);
    if (!(route && route.feature)) return false;
    return route.feature.visible;
  }
  SetNodeVis(node: RouteTreeNode, isVis: boolean) {
    if (node.id <= 0) {
      return;
    }
    const route = this.route.GetRoute(node.id);
    if (route && route.feature) {
      route.feature.visible = !!isVis;
    }
    RoutesService.Notify('route-vis-changed', node.id as number);
  }
  Config(node: RouteTreeNode) {
    if (node.id <= 0) return;
    const route = this.route.GetRoute(node.id);
    this.config.Show({
      cancelHandler: () => { },
      okHandler: (params: RouteConfigOKHandlerParams) => {
        node.name = params.route.name;
        this.UpdateTree(false);

      },
      route: (route)
    })

  }
  StartBranchMerge() {
    const drawPane: DrawPaneComponent | undefined = (this.route?.context! as Project).drawPane;

    if (this.isBranchMerging) {
      this.branchMerging = undefined;
      if (!!drawPane) {
        drawPane.drawMode = 'feature';
      }
      this.Refresh();
      return;
    }
    if (!this.selectedNode) return;


    const selected = this.route.GetRoute(this.selectedNode.id);
    if (selected?.feature === undefined) return;
    this.branchMerging = { route: selected, feature: selected.feature.GetSelectedInfo() };
    if (!!drawPane) {
      drawPane.StartMerge(this.branchMerging);
    }

  }
  MergeBranches(route: RouteInfo, feature: any) {
    const merging = this.branchMerging;
    if (!merging) return;
    this.branchMerging = undefined;
    if (route.id === merging.route.id) return;
    if (!merging.feature) {
      merging.feature = route.feature?.GetSelectedInfo();
    }
    if (!merging.feature) return;
    const mergeType = merging.feature.type + '-' + feature.type;
    if (!route) return;
    if (!feature) return;
    let hasIntersection = false;
    if (merging.feature.id !== feature.id) {
      hasIntersection = route.feature!.FeatureIntersects(merging.feature, feature);
    }
    switch (mergeType) {
      case 'point-point':
        if (!!hasIntersection) {
          if (feature.routes.indexOf(merging.route.feature.id) === -1) {
            feature.MergeVertex();
            feature.share(merging.route.feature.id);
            this.ResetMerging();
            merging.route.feature.Select(feature.id);
            return;
          }
        }
        merging.route.feature.AddVertex(feature);
        merging.route.feature.Select(feature.id);

        break;
      case 'point-segment':
        {
          if (!!hasIntersection) {
            route.feature!.AddVertex(merging.feature.ui);
            this.ResetMerging();
            return;
          }
          const pt = feature.split();
          merging.route.feature.AddVertex(feature);
          merging.route.feature.Select(feature.id);

        }
        break;
      case 'segment-point':
        {
          if (!!hasIntersection) {
            merging.feature.AddExistingVertex(feature);
            this.ResetMerging();
            merging.route.feature.Select(feature.id);
            return;
          }
          merging.feature.AddExistingVertex(feature);
          merging.route.feature.Select(feature.id);
        }

        break;
      case 'segment-segment':
        if (!!hasIntersection) {
          const xSect = route.feature?.SegmentIntersection(feature, merging.feature);
          if (xSect) {
            const vertex = feature.AddVertex(xSect.pixo.x, xSect.pixo.y);
            merging.feature.AddExistingVertex(vertex);
            merging.route.feature.Select(vertex.id);
            this.ResetMerging();
            return;
          }

        }
        const featureVertex = feature.split();
        const mergingVertex = merging.feature.split();
        route.feature?.Select(featureVertex.id, route.feature.id);
        feature.AddVertex(mergingVertex);
        break;
    }
    this.ResetMerging();
  }
  ResetMerging() {
    this.branchMerging = undefined;
    this.Refresh();
  }
  IsMerging(id: ObjID): boolean {
    if (!this.isBranchMerging) return false;
    return (this.branchMerging?.route.id === id);
  }
  CenterOnRoute(id: ObjID) {
    RoutesService.Notify('jump-to-route', id as number);
  }
  DeleteSelected(id: ObjID) {
    RoutesService.Notify('delete-selected', id as number)
  }
  DeleteAll(id: ObjID) {
    RoutesService.Notify('delete-all', id as number);
  }
  GPSAdd(id: ObjID) {
    RoutesService.Notify('gps-add', id as number);
  }
  GPSUpdate(id: ObjID) {
    RoutesService.Notify('gps-update', id as number);
  }
}
